// UserMoreJsonLd.js
import { connect } from 'react-redux';

import UserMoreJsonLd from '../component/UserMoreJsonLd.jsx';

import getListData from '../selector/getListData.js';
import getUserDataList from '../selector/getUserDataList.js';

const mapStateToProps = (state, { category }) => {
  const selectPath = ['home', 'users', category];
  const userIds = getListData(state, selectPath, 'itemIds');
  return {
    userDataList: getUserDataList(state, userIds),
  };
};

export default connect(mapStateToProps)(UserMoreJsonLd);
